<app-waitron-page-loader
  [show]="loading"
  message="Loading menu..."
  [fullscreen]="true"
  [overlay]="true"
></app-waitron-page-loader>

<div class="menu-page-loading" *ngIf="loading">
  <div class="menu-page-loading__card">
    <div class="menu-page-loading__spinner" aria-hidden="true"></div>
    <p>Loading menu...</p>
  </div>
</div>

<ng-container *ngIf="!loading">
  <app-restaurant-header
    [restaurantName]="
      restaurantInfo ? restaurantInfo.tenant.companyName : 'Restaurant'
    "
    [restaurantAddress]="restaurantAddress"
    [deliveryTime]="'20 - 40'"
    [openingTime]="todayStoreHours ? formatTime(todayStoreHours.openTime) : '-'"
    [closingTime]="
      todayStoreHours ? formatTime(todayStoreHours.closeTime) : '—'
    "
    [isClosed]="isRestaurantClosed"
    [openingTimeRaw]="todayStoreHours?.openTime ?? undefined"
    [closingTimeRaw]="todayStoreHours?.closeTime ?? undefined"
    [minOrder]="minimumOrderAmount || 0"
    [deliveryFee]="publicDeliveryRules?.deliveryCharge || 0"
    [rating]="4.0"
    [reviewCount]="500"
    [hygieneRating]="'Good'"
    [hygieneUrl]="
      'https://ratings.food.gov.uk/business/' +
      restaurantInfo?.tenant?.foodHygieneId
    "
    [allergensNote]="allergensNote"
    [orderType]="orderType"
    (orderTypeChange)="onOrderTypeChange($event)"
    [openingHours]="openingHoursWeekly"
    [deliveryHours]="deliveryHoursWeekly"
    [fees]="fees"
    [deliveryToggleNote]="deliveryToggleNote"
  >
  </app-restaurant-header>

  <div class="tb" *ngIf="menuCategories.length > 0">
    <div class="nav">
      <button
        type="button"
        class="nav-btn"
        aria-label="Scroll categories left"
        (click)="scrollCategoryRow('left')"
      >
        <i class="fa-solid fa-chevron-left"></i>
      </button>

      <div
        #categoryScroll
        class="cat-row"
        role="tablist"
        aria-label="Menu categories"
      >
        <button
          *ngFor="let category of menuCategories"
          type="button"
          (click)="onCategoryPillClick(category.categoryName)"
          class="cat"
          [class.active]="category.categoryName === currentCategory"
          [attr.aria-selected]="category.categoryName === currentCategory"
          [attr.data-category]="category.categoryName"
        >
          {{ category.categoryName }}
        </button>
      </div>

      <button
        type="button"
        class="nav-btn"
        aria-label="Scroll categories right"
        (click)="scrollCategoryRow('right')"
      >
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
  <div class="page">
    <div class="main">
      <div class="menu-sections" *ngIf="!loading && !error">
        <ng-container *ngIf="menuCategories.length > 0; else noMenus">
          <div
            *ngFor="let category of menuCategories"
            [attr.id]="categoryDomId(category.categoryName)"
            class="sec"
          >
            <h2>{{ category.categoryName }}</h2>
            <div class="grid">
              <div
                *ngFor="let item of category.items! | menuFilter: searchQuery"
                class="item"
                (click)="openModal(item)"
              >
                <div class="item-top">
                  <div class="info">
                    <h3>{{ item.itemName }}</h3>
                    <p>{{ item.itemDescription }}</p>
                  </div>
                </div>

                <div class="foot">
                  <div class="price">
                    {{ item.basePrice | currency: "GBP" }}
                  </div>
                  <i class="fas fa-plus plus"></i>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <ng-template #noMenus>
          <div class="empty">
            <h2>No menus available</h2>
            <p>Please check back later. We're cooking something up!</p>
            <img src="/images/empty-menu.svg" alt="No menu illustration" />
          </div>
        </ng-template>
      </div>
    </div>

    <div class="cart-col">
      <app-cart
        [orderType]="orderType"
        [deliveryFeeOriginalGross]="publicDeliveryRules?.deliveryCharge || 0"
        [serviceFee]="serviceFee"
        [minimumDeliveryAmount]="
          publicDeliveryRules?.minimumDeliveryAmount || 0
        "
        [minimumOrderAmount]="minimumOrderAmount"
        [smallOrderFee]="smallOrderFee"
        [deliveryDisabled]="!isDeliverySelectable"
        [deliveryToggleLabel]="cartDeliveryToggleLabel"
        (orderTypeChange)="onOrderTypeChange($event)"
        (checkout)="handleCheckout()"
      ></app-cart>
    </div>
  </div>

  <axis-modal
    [show]="modalOpen"
    (closed)="closeDetailModal()"
    [closeOnBackdrop]="true"
    [disableEscape]="false"
    style="--modal-width: 500px"
    class="item-modal"
  >
    <!-- header slot -->
    <div modal-header class="info-modal__header">
      <div class="modal-title">
        <h2 class="info-modal__title">{{ selectedItem?.itemName }}</h2>
        <p>{{ selectedItem?.itemDescription }}</p>
      </div>
      <button
        type="button"
        aria-label="Close information modal"
        class="info-modal__close"
        (click)="closeDetailModal()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <!-- body (default slot) -->
    <!-- Variant Selector -->
    <div *ngIf="selectedItem?.variants?.length! > 0" class="variants">
      <label
        *ngFor="let variant of selectedItem?.variants"
        class="variant"
      >
        <input
          type="radio"
          name="variant"
          [value]="variant"
          [(ngModel)]="selectedVariant"
          (change)="onVariantChanged(variant)"
        />
        {{ variant.name }} ({{ variant.price | currency: "GBP" }})
      </label>
    </div>

    <div *ngIf="selectedItem?.options?.length" class="opts">
      <div
        *ngFor="let group of selectedItem?.options"
        class="group"
        [attr.data-group]="group.groupName"
        [class.miss]="groupMissingRequired(group)"
      >
        <div class="extra-head">
          <h4>
            {{ group.groupName }}
            <span class="req" *ngIf="groupMinRequired(group) > 0">
              Required
            </span>
          </h4>

          <p class="max" *ngIf="group.maxSelect">
            Max {{ group.maxSelect }} choice{{ group.maxSelect > 1 ? "s" : "" }}
            allowed
          </p>

          <p class="req-msg" *ngIf="groupMissingRequired(group)">
            Please select {{ groupMinRequired(group) }} option{{
              groupMinRequired(group) > 1 ? "s" : ""
            }}
            to continue.
          </p>
        </div>

        <label
          *ngFor="let extra of group.extras"
          class="choice"
          [class.off]="extra.isActive === '0'"
        >
          <input
            type="checkbox"
            [disabled]="
              extra.isActive === '0' ||
              (isGroupMaxed(group.groupName) &&
                !selectedOptionGroups[group.groupName][extra.extraName])
            "
            [(ngModel)]="selectedOptionGroups[group.groupName][extra.extraName]"
            (change)="onExtraToggled(group.groupName, extra)"
          />
          {{ extra.extraName }}
          <span *ngIf="extra.priceAdjustment > 0">
            (+{{ extra.priceAdjustment | currency: "GBP" }})
          </span>
        </label>
      </div>
    </div>

    <div class="ctas">
      <div class="selectors">
        <p class="m-price">
          Price: {{ calculatedModalPrice | currency: "GBP" }}
        </p>

        <div class="qty">
          <button type="button" (click)="decreaseQty()">-</button>
          <span>{{ quantity }}</span>
          <button type="button" (click)="increaseQty()">+</button>
        </div>
      </div>

      <div modal-footer class="info-modal__footer">
        <button
          class="btn-primary basket"
          [disabled]="isOrderingDisabled"
          [class.is-disabled]="missingRequiredOptions"
          [attr.aria-disabled]="isOrderingDisabled || missingRequiredOptions"
          (click)="addToBasket()"
        >
          Add to Basket
        </button>
      </div>
    </div>
  </axis-modal>

  <axis-modal
    [show]="isRestaurantClosed"
    [closeOnBackdrop]="false"
    [disableEscape]="true"
  >
    <div modal-header class="info-modal__header">
      <h2 class="info-modal__title">We’re Currently Closed</h2>
    </div>

    <div>
      <ng-container
        *ngIf="isClosedVal(todayStoreHours?.isClosed); else timeBasedTpl"
      >
        <p>
          We’re not open today.
          <ng-container *ngIf="nextStoreOpening; else noFutureTpl">
            Our next opening will be on
            <strong>{{ nextStoreOpening.openingDay }}</strong>
            between
            <strong>{{ formatTime(nextStoreOpening.openTime) }}</strong>
            and
            <strong>{{ formatTime(nextStoreOpening.closeTime) }}</strong
            >.
          </ng-container>
        </p>

        <ng-template #noFutureTpl>
          <p>
            We don’t currently have any opening hours scheduled for the coming
            days.
          </p>
        </ng-template>
      </ng-container>

      <ng-template #timeBasedTpl>
        <p>
          We’re currently closed. Today’s opening hours are
          <strong>{{
            todayStoreHours ? formatTime(todayStoreHours.openTime) : "—"
          }}</strong>
          to
          <strong>{{
            todayStoreHours ? formatTime(todayStoreHours.closeTime) : "—"
          }}</strong>
          <ng-container *ngIf="isOvernightDisplay(todayStoreHours)">
            <span> next day</span>
          </ng-container>
        </p>
      </ng-template>
    </div>
  </axis-modal>

  <axis-modal
    [show]="showDeliveryClosedModal && !isRestaurantClosed"
    (closed)="onCloseDeliveryClosedModal()"
    [closeOnBackdrop]="true"
    [disableEscape]="false"
    style="--modal-width: 520px"
  >
    <div modal-header class="info-modal__header">
      <h2 class="info-modal__title">Delivery Unavailable</h2>
      <button
        type="button"
        aria-label="Close information modal"
        class="info-modal__close"
        (click)="onCloseDeliveryClosedModal()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="modal-content" [ngSwitch]="deliveryStatus">
      <!-- No deliveries today -->
      <p *ngSwitchCase="'closedAllDay'">
        We’re not delivering today. You can still order for collection until
        <strong>{{
          todayStoreHours ? formatTime(todayStoreHours.closeTime!) : "—"
        }}</strong
        >.
      </p>

      <!-- Before deliveries start -->
      <p *ngSwitchCase="'before'">
        Our delivery times today are
        <strong>{{ formatTime(todayDeliveryHours!.openTime!) }}</strong>
        – <strong>{{ formatTime(todayDeliveryHours!.closeTime!) }}</strong
        >. Deliveries start at
        <strong>{{ formatTime(todayDeliveryHours!.openTime!) }}</strong
        >. You can still order for collection until
        <strong>{{
          todayStoreHours ? formatTime(todayStoreHours.closeTime!) : "—"
        }}</strong
        >.
      </p>

      <!-- After deliveries end -->
      <p *ngSwitchCase="'after'">
        We’ve finished deliveries for today (last delivery at
        <strong>{{ formatTime(todayDeliveryHours!.closeTime!) }}</strong
        >). You can still order for collection until
        <strong>{{
          todayStoreHours ? formatTime(todayStoreHours.closeTime!) : "—"
        }}</strong
        >.
      </p>

      <!-- Fallback (unknown/during) -->
      <p *ngSwitchDefault>
        Delivery is currently unavailable. You can still order for collection
        until
        <strong>{{
          todayStoreHours ? formatTime(todayStoreHours.closeTime!) : "—"
        }}</strong
        >.
      </p>

      <div
        style="
          margin-top: 1rem;
          display: flex;
          gap: 0.5rem;
          justify-content: flex-end;
        "
      >
        <button class="btn-primary" (click)="onCloseDeliveryClosedModal()">
          OK, got it
        </button>
      </div>
    </div>
  </axis-modal>

  <axis-modal
    [show]="showPauseOrdersModal && !isRestaurantClosed"
    (closed)="onClosePauseOrdersModal()"
    [closeOnBackdrop]="true"
    [disableEscape]="false"
    style="--modal-width: 520px"
  >
    <div modal-header class="info-modal__header">
      <h2 class="info-modal__title">Orders Temporarily Paused</h2>

      <button
        type="button"
        aria-label="Close information modal"
        class="info-modal__close"
        (click)="onClosePauseOrdersModal()"
      >
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <div class="modal-content">
      <p *ngIf="pauseUntilLabel; else pausedIndefinite">
        We’re not taking
        <strong>
          {{
            pauseModalType === "both"
              ? "Delivery or Collection"
              : (pauseModalType || orderType | titlecase)
          }}
        </strong>
        orders right now. Please check back after
        <strong>{{ pauseUntilLabel }}</strong
        >.
      </p>

      <ng-template #pausedIndefinite>
        <p>
          We’re not taking
          <strong>
            {{
              pauseModalType === "both"
                ? "Delivery or Collection"
                : (pauseModalType || orderType | titlecase)
            }}
          </strong>
          orders right now. Please check back soon.
        </p>
      </ng-template>

      <p *ngIf="isAllOrderingPaused" style="opacity: 0.85">
        Collection and delivery are currently paused.
      </p>

      <div
        style="
          margin-top: 1rem;
          display: flex;
          gap: 0.5rem;
          justify-content: flex-end;
        "
      >
        <!-- Optional: quick switch CTA -->
        <button
          *ngIf="
            orderType === 'delivery' &&
            pauseActive &&
            pauseClosedDelivery &&
            !pauseClosedCollection
          "
          class="btn-primary"
          (click)="onOrderTypeChange('collection')"
        >
          Switch to collection
        </button>

        <button class="btn-primary" (click)="onClosePauseOrdersModal()">
          OK
        </button>
      </div>
    </div>
  </axis-modal>
</ng-container>
